<template>
  <LayoutDashboard title="Relatório de OS">
    <v-card outlined>
      <v-card-title>Relatório de OS por período.</v-card-title>
      <v-card-text>
        <v-form ref="formRelOsPeriodo" class="px-3">
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-select
                :items="['', ...getFormasPagamento]"
                item-text="nome"
                item-value="id"
                v-model="dadosRelatorioOsPeriodo.formaPagamentoId"
                label="Forma de Pagamento"
                outlined
                dense
                class="mr-2 ml-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                v-model="dadosRelatorioOsPeriodo.periodo_inicial"
                label="Periódo Inicial"
                outlined
                dense
                type="date"
                class="ml-1 mr-1"
                :rules="rules.periodo_inicial"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
              <v-text-field
                v-model="dadosRelatorioOsPeriodo.periodo_final"
                label="Periódo Final"
                outlined
                dense
                type="date"
                class="ml-1 mr-1"
                :rules="rules.periodo_final"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <v-autocomplete
                :items="['', ...getFuncionarios]"
                item-value="id"
                item-text="nome_abreviado"
                label="Técnico"
                outlined
                dense
                class="ml-1 mr-1"
                v-model="dadosRelatorioOsPeriodo.tecnicoId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md2>
              <v-select
                :items="getStatusOrdemServico"
                v-model="dadosRelatorioOsPeriodo.status"
                label="Status"
                outlined
                dense
                append-outer-icon="print"
                class="ml-1 mr-1"
                @click:append-outer="gerarRelatorioOsPeriodo()"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </LayoutDashboard>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      dadosRelatorioOsPeriodo: {
        periodo_inicial: "",
        periodo_final: "",
        tecnicoId: "",
        status: "",
        formaPagamentoId: ""
      },
      rules: {
        periodo_inicial: [(v) => !!v || "Campo obrigatório."],
        periodo_final: [(v) => !!v || "Campo obrigatório."],
      }
    };
  },
  computed: {
    ...mapGetters(["getFuncionarios", "getStatusOrdemServico", "getFormasPagamento"]),
  },
  methods: {
    ...mapActions(["gerarRelatorioPorPeriodoOS", "listarFormaPagamento"]),
    gerarRelatorioOsPeriodo() {
      if (this.$refs.formRelOsPeriodo.validate() == false) {
        return;
      }

      this.gerarRelatorioPorPeriodoOS(this.dadosRelatorioOsPeriodo);
    },
  },
  created(){
    this.listarFormaPagamento()
  }
};
</script>